export const UiActions = {
  headerSize: "UPDATE_HEADER_SIZE",
  footerSize: "UPDATE_FOOTER_SIZE",
  width: "UPDATE_WIDTH",
  height: "UPDATE_HEIGHT",
  scroll: "UPDATE_SCROLL",
  appLoading: "UPDATE_APP_LOADING",
};
